import React from 'react'
import Anime from 'react-anime'
import Link, { withPrefix } from 'gatsby-link'
import moment from 'moment'
import tripData from '../data/trip.json'
import Countdown from '../components/countdown'
import Timeline from '../components/timeline'

const IndexPage = ({ data }) => {
  const startOfTrip = moment(tripData[0].start)
  // const now = moment('2018-09-12 20:00:00+12:00')
  const now = moment()
  return (
    <section
      className="hero is-fullheight is-primary"
      style={{
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: 'black',
      }}
    >
      <video
        autoPlay
        muted
        loop
        playsInline
        id="palceholderVideo"
        className="video-bg"
      >
        <source src={withPrefix('/plane-placeholder.mp4')} type="video/mp4" />
      </video>
      <div className="hero-body">
        <div className="container has-text-centered">
          <Anime opacity={[0, 1]} delay={(e, i) => i * 1}>
            <h4 className="title is-4" style={{ marginBottom: '0' }}>
              Where in the world are
            </h4>
            <h1 className="title is-1 is-script-font">Jordan &amp; Seth?</h1>
            <div>
              {now.isBefore(startOfTrip) ? (
                <Countdown to={startOfTrip} from={now} />
              ) : (
                <Timeline
                  data={tripData.filter(leg => now.isAfter(moment(leg.start)))}
                  now={now}
                />
              )}
            </div>
          </Anime>
        </div>
      </div>
    </section>
  )
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js